// Generated by GitHub Copilot
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Wrench } from 'lucide-react'

export const Route = createFileRoute('/_appSettings/$companyId/settings/$panel')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation('settings')
  return (
    <div className="ynt-centered-empty-state">
      <Wrench width={40} height={40} strokeWidth={1.5} />
      <h4 className="mb-0">{t('page.underConstructionTitle')}</h4>
      <p className="mb-0">{t('page.underConstructionMessage')}</p>
    </div>
  )
}
